import { Validator } from '@vista-digital/validator';
export const defaultOccMemberDisplayText = {
    defaultBalanceTypeName: 'Points',
    defaultBalanceTypeUnitName: 'points',
    memberBalanceFormat: '${units|n} ${unitName}',
    rewardExclusiveLabel: 'Just for you',
    friendCodeFormat: '**** **** **** **** ****'
};
const friendCodeFormatValidator = (value, logger, logLabel) => {
    // Friend codes have a fixed length of 20 alphanumeric characters in Loyalty.
    const expectedFriendCodeLength = 20;
    // Must have the correct number of placeholder characters.
    const numberOfPlaceholderCharacters = (value.match(/\*/g) || []).length;
    if (numberOfPlaceholderCharacters !== expectedFriendCodeLength) {
        logger(`${logLabel} must contain ${expectedFriendCodeLength} '*' placeholder characters.`);
        return false;
    }
    // Must have 0 alphanumeric characters
    const numberOfAlphanumericCharacters = (value.match(/[a-z0-9]/gi) || []).length;
    if (numberOfAlphanumericCharacters !== 0) {
        logger(`${logLabel} must not contain any alphanumeric characters.`);
        return false;
    }
    return true;
};
export const occMemberDisplayTextValidator = Validator.object({
    defaultBalanceTypeName: Validator.nonEmptyString,
    defaultBalanceTypeUnitName: Validator.nonEmptyString,
    memberBalanceFormat: Validator.nonEmptyString,
    rewardExclusiveLabel: Validator.nonEmptyString,
    friendCodeFormat: friendCodeFormatValidator
});
//# sourceMappingURL=member.js.map